import React, { useLayoutEffect } from 'react'
import { HeaderStyle } from './style'
import LanguageSwitcher from 'components/LanguageProvider/components/LanguageSwitcher'
import { Icon } from '../Icon'
import Logo from '../Logo'
import { useDispatch, useSelector } from 'react-redux'
import { showHeader, hideHeader } from './slices'

const Header = () => {
	const dispatch = useDispatch()
	const { headerClass } = useSelector((state) => state.header)
	const { currentTheme } = useSelector((state) => state.root)
	const logoEnabled = useSelector(
		({ root }) => root.shopProperties['widget.shop.logo.enabled']
	)
	const languageDisabled = useSelector(
		({ root }) => root.shopProperties['widget.lang.select.disabled']
	)

	useLayoutEffect(() => {
		let getPosition = () => {
			let body = document.body //IE 'quirks'
			let doc = document.documentElement //IE with doctype
			let docElement = doc.clientHeight ? doc : body

			if (docElement.scrollTop === 0) {
				if (headerClass !== 'visible') {
					dispatch(showHeader())
				}
			} else {
				if (headerClass !== 'invisible') {
					dispatch(hideHeader())
				}
			}
		}

		window.addEventListener('scroll', getPosition)
	})

	return (
		<HeaderStyle headerClass={headerClass}>
			<div className='col col-4'>
				{logoEnabled === 'false' ? '' : <Logo />}
			</div>
			<div className='col col-4 d-flex justify-content-center'>
				{languageDisabled === 'false' ? <LanguageSwitcher /> : ''}
			</div>
			<div className='col col-4 d-flex justify-content-end'>
				<Icon
					fill={currentTheme?.color?.headerLogo}
					className='logoReturnado'
					component='LogoReturnado'
				/>
			</div>
		</HeaderStyle>
	)
}
export default Header
